export const moduleKeys = {
  recordAudit: 'recordAudit',
  rentalOrder: 'rentalOrder',
  core: 'core',
  vehicles: 'vehicles',
  sourcing: 'sourcing',
  quickPurchase: 'quickPurchase',
  customers: 'customers',
  businessCase: 'business-case',
  communication: 'communication',
  telephony: 'telephony',
  accounting: 'accounting',
  employee: 'employee',
  workshop: 'workshop',
  warehouse: 'warehouse',
  restrictedArea: 'restricted-area',
  inspection: 'inspection',
  settings: 'settings',
  analytics: 'analytics',
  salesLeague: 'sales-league',
  tiresInventory: 'tires-inventory',
  interest: 'interest',
  taskManager: 'task-manager',
  testDrive: 'test-drive',
  auction: 'auction',
  myProfile: 'my-profile',
  import: 'import',
  opportunitiesKanban: 'opportunities-kanban',
  orchestration: 'orchestration',
} as const;
